import { IDocument, LayoutConfigOption, TagFilter } from "@vp/models";
import { JSONSchema7 } from "json-schema";
import { PatientConsoleDeviceData } from "./patient-console-device-data";
import { Profile } from "./profile";
import { UserRole } from "./user-role";

export interface User extends IDocument {
  userId: string;
  userType: UserType;
  isOnline: boolean;
  email: string;
  profile: Profile;
  roles: UserRole[];
  active: boolean;
  tags: string[];
  assignedTags: string[];
  selectedRoleId: string;
  //selectedRoleFriendlyId: string;
  lastLoginDateTime?: string;
  invitationEmail?: UserInvitationEmail;
  userData?: UserData;
  patientConsoleDeviceData?: PatientConsoleDeviceData;
  deviceAssignmentData?: DeviceAssignmentData | null;
  acesoTvDeviceData?: AcesoTvDeviceData;
  userPermissions: UserPermissions[];
  callData?: CallData;
  //TODO Remove zoomCallData field when vPAC is updated with the new CallData field
  zoomCallData?: ZoomCallData;
}

export interface DeviceAssignmentData {
  currentAssignment: DeviceAssignment;
  previousAssignment: DeviceAssignment;
}

export interface DeviceAssignment {
  caseId: string | null;
  location: string | null;
}

export interface AcesoTvDeviceData {
  camera: boolean;
  channel: number;
  power: "off" | "on"; // represents the TV glass state.
  volume: number;
  glass: "off" | "on"; // represents the screen visible state
  blackout: "off" | "on"; // represents the blackout curtain state.
  pan: number;
  tilt: number;
  zoom: number;
}

export interface UserInvitationEmail {
  subject: string;
  body: string;
}

export interface UserPermissions {
  roleId: string;
  moduleId: string;
  permissionSets: string[];
}

export interface TagsDeleted {
  [key: string]: string[];
}

export interface UserType {
  userTypeId: string;
  friendlyId: UserTypeFriendlyId;
  displayName: string;
}

export enum UserTypeFriendlyId {
  loginUser = "login-user",
  nonLoginUser = "non-login-user",
  device = "device",
  acesoTv = "aceso-tv"
}

export interface UserData {
  acknowledgedAlerts?: string[];
  snippets?: Snippet[];
  tagFilters?: TagFilter[];
  flags: { [key: string]: boolean };
  [key: string]: any;
  informaticistProfile?: InformaticistProfile;
  permissions: string[];
  userPermissions: UserPermissions[];
  lastModuleVisited: string;
}

export interface Snippet {
  title: string;
  text: string;
}

export interface InformaticistProfile {
  available: boolean;
  assignedFacilities: string[];
  assignedTopics: string[];
}

/**@deprecated
 * usages of this should be replaced with just the id of the user and resolved when used.
 * */
export interface UserLite {
  email: string;
  firstName: string;
  lastName: string;
  salutation: string;
  userId: string;
  isOnline: boolean;
  deviceAssignmentData?: DeviceAssignmentData | null;
}

export interface Flag {
  [key: string]: boolean;
}

export interface UserTypeConfig {
  type: string;
  singleRoleAssignment: boolean;
  singleDepartmentAssignment: boolean;
  assignableRoleFriendlyId: string[];
  assignableDepartmentFriendlyId: string[];
  userSchema: JSONSchema7;
  userLayout: LayoutConfigOption;
}

export interface CallData {
  zoomAuthenticated?: boolean;
  active: boolean;
  applicationHostId: string;
  topic: string;
  lastUpdatedBy: string;
  lastUpdatedDateTime: string;
}

// TODO: Remove this field when vPAC is updated with the new CallData field
export interface ZoomCallData {
  zoomAuthenticated?: boolean;
}
